export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      totalItems: null,
    };
  },
  methods: {
    setPagination: function (pagination, pageSize = 10) {
      this.page = pagination.pageNumber;
      this.pageSize = pageSize;
    },
  },
};
